import { useState } from 'react';
import axios from './waistApi';
import { displayWaist, errorMessage, localDateTime, toCentimeters } from './waistUtils';

export default function WaistForm({ record, userId, onSuccess, onCancel, admin = false }) {
  const [value, setValue] = useState(record ? String(record.waistInCm) : '');
  const [unit, setUnit] = useState('cm');
  const [canonicalCm, setCanonicalCm] = useState(record?.waistInCm ?? null);
  const [notes, setNotes] = useState(record?.notes || '');
  const [recordedAt, setRecordedAt] = useState(record?.recordedAt?.slice(0, 16) || localDateTime());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const save = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError('');
    try {
      const waistInCm = canonicalCm ?? toCentimeters(value, unit);
      if (!recordedAt || !Number.isFinite(new Date(recordedAt).getTime())) throw new Error('請填寫有效的測量時間。');
      if (notes.length > 255) throw new Error('備註最多 255 字。');
      // Preserve seconds and precision when the user only changes notes.
      const payload = { waistInCm, notes, recordedAt: record && recordedAt === record.recordedAt.slice(0, 16) ? record.recordedAt : recordedAt };
      setBusy(true);
      if (record) await axios.put(`${admin ? '/api/Admin/waist' : '/api/Waist'}/${record.id}`, payload);
      else await axios.post('/api/Waist', { ...payload, ...(userId ? { userId } : {}) });
      onSuccess();
    } catch (err) { setError(errorMessage(err)); }
    finally { setBusy(false); }
  };
  let equivalent = '';
  try { equivalent = displayWaist(toCentimeters(value, unit), unit === 'cm' ? 'in' : 'cm'); } catch { /* incomplete input */ }
  return <form onSubmit={save}>
    {error && <div role="alert" className="alert alert-danger">{error}</div>}
    <fieldset disabled={busy}>
      <div className="mb-3"><label className="form-label">輸入單位
        <select className="form-select" value={unit} onChange={e => {
          const next = e.target.value;
          if (canonicalCm !== null) setValue(String(next === 'in' ? canonicalCm / 2.54 : canonicalCm));
          setUnit(next);
        }}><option value="cm">公分 (cm)</option><option value="in">英吋 (in)</option></select>
      </label></div>
      <div className="mb-3"><label className="form-label">腰圍 ({unit})
        <input className="form-control" inputMode="decimal" value={value} onChange={e => {
          setValue(e.target.value);
          try { setCanonicalCm(toCentimeters(e.target.value, unit)); } catch { setCanonicalCm(null); }
        }} required />
      </label>{equivalent && <div className="form-text">約 {equivalent} {unit === 'cm' ? '英吋' : '公分'}</div>}</div>
      <div className="mb-3"><label className="form-label">測量時間
        <input className="form-control" type="datetime-local" value={recordedAt} onChange={e => setRecordedAt(e.target.value)} required />
      </label></div>
      <div className="mb-3"><label className="form-label">備註
        <input className="form-control" maxLength={255} value={notes} onChange={e => setNotes(e.target.value)} />
      </label></div>
      <button className="btn btn-primary me-2" type="submit">{busy ? '儲存中…' : '儲存'}</button>
      {onCancel && <button className="btn btn-secondary" type="button" onClick={onCancel}>取消</button>}
    </fieldset>
  </form>;
}
